import fetch from 'isomorphic-fetch';
import { checkStatus } from '../../util';
import { ROOT } from '../../../constants/root';

export function getTypes() {
	return function(dispatch, getState) {		

		const URL = `${ROOT}/type/`;		

		return fetch(URL, {
			method: 'GET',
			headers: {
				'Authorization': 'Token ' + getState().login.credentials.token,
				'Content-Type': 'application/json'
			}
		})
		.then((response) => checkStatus(response, dispatch))
		.then((response) => response.json())
		.then((json) => {
			dispatch(setTypesList(json));
		})
		.catch((e) => {
			console.error(e);			
		});
	};
}

function setTypesList(types) {
	return {
		type: "SET_TYPES_LIST",
		types
	};	
}


// WEBPACK FOOTER //
// ./src/state/domains/types/actions.js